import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { Path } from 'config/portal'
import { selectors as globalSelectors } from '../../reducer'
import SharedAddNewServicesAgreementView from '../../products/views/AddNewServicesAgreementView'

function mapStateToProps(state) {
  return {
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    currentUser: globalSelectors.currentUser(state),
    formType: 'taxable-accounts',
    nextPath: Path.SELECT_TAXABLE_ACCOUNTS_COMPANY_INFORMATION,
  }
}

const mapDispatchToProps = {
  setCompleteServicesAgreementForm: actions.setCompleteServicesAgreementForm,
  resetErisapediaSearches: actions.resetErisapediaSearches,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SharedAddNewServicesAgreementView
)
